module.exports = __webpack_public_path__ + "img/copy-blue.57e18412.svg";